import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { googleLogout } from '@react-oauth/google';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  const getUserInfo = () => {
    try {
      const userInfo = localStorage.getItem('user_info');
      return userInfo ? JSON.parse(userInfo) : null;
    } catch (error) {
      console.error('Error parsing user info:', error);
      return null;
    }
  };

  const user = getUserInfo();
  const isAuthenticated = !!localStorage.getItem('google_token');

  const handleLogout = () => {
    googleLogout();
    localStorage.removeItem('google_token');
    localStorage.removeItem('user_info');
    navigate('/');
    setIsMobileMenuOpen(false); // Close mobile menu on logout
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <nav className="navbar">
          <div className="logo">
            <Link to="/"><img src="Images/logo.png" alt="" width={30} height={30} /> Analytic Byte</Link>
          </div>
          
          {/* Mobile Menu Toggle Button */}
          <button 
            className="mobile-menu-toggle"
            onClick={toggleMobileMenu}
            aria-label="Toggle navigation menu"
          >
            <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </button>
          
          {/* Desktop Navigation */}
          <ul className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
            <li>
              <Link 
                to="/" 
                className={isActive('/') ? 'active' : ''}
                onClick={closeMobileMenu}
              >
                <i className="fas fa-home"></i>
                <span>Home</span>
              </Link>
            </li>
            
            <li>
              <Link 
                to="/services" 
                className={isActive('/services') ? 'active' : ''}
                onClick={closeMobileMenu}
              >
                <i className="fas fa-info-circle"></i>
                <span>Services</span>
              </Link>
            </li>
            
            <li>
              <Link 
                to="/contact" 
                className={isActive('/contact') ? 'active' : ''}
                onClick={closeMobileMenu}
              >
                <i className="fas fa-envelope"></i>
                <span>Contact</span>
              </Link>
            </li>
            <li>
              <Link 
                to="/dashboard" 
                className={isActive('/dashboard') ? 'active' : ''}
                onClick={closeMobileMenu}
              >
                <i className="fas fa-tachometer-alt"></i>
                <span>Dashboard</span>
              </Link>
            </li>    
              
                
            {isAuthenticated ? (
              <>
                <li className="user-info">
                  {user?.picture && (
                    <img 
                      src={user.picture} 
                      alt={user.name || 'User'} 
                      className="user-avatar"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  )}
                  <span className="user-name">{user?.name || 'User'}</span>
                  <button onClick={handleLogout} className="logout-btn">
                    <i className="fas fa-sign-out-alt"></i>
                    <span>Logout</span>
                  </button>
                </li>
              </>
            ) : (
              <li className="login-button-container">
                <Link 
                  to="/login" 
                  className={`login-btn btn btn-primary ${isActive('/login') ? 'active' : ''}`}
                  onClick={closeMobileMenu}
                >
                  <i className="fas fa-sign-in-alt"></i>
                  <span>Sign In</span>
                </Link>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;